export default __webpack_public_path__ + "static/media/Home Link_logo.6b10bc9e.jpg";